var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.DataTypeLightning = {
    keys: [],
    is_gridded: function () {
        return false;
    },
    get_data_variable: function () {
        return this.data();
    },
    get_variables: function () {
        return ["lightning"];
    },
    get_variable_units: function () {

    },
    add_data_variable: function (data_in, key) {
        var existing_data = this.data().features;
        if (data_in && data_in.type === "Feature") {
            if (!key || !this.keys.contains(key)) {
                this.keys.push(key);
                if (key) {
                    existing_data.push(data_in);
                } else {
                    existing_data.combine([data_in]);
                }
            }
        }
        if (data_in && data_in.type === "FeatureCollection" && data_in.features && data_in.features.length) {
            var i = 0;
            var feature, feature_key;
            if (key && typeof (key) === 'function') {
                for (i; i < data_in.features.length; i++) {
                    feature = data_in.features[i];
                    if (feature && feature.type === "Feature") {
                        this.add_data_variable(feature, key(feature));
                    }
                }
            } else {
                existing_data.combine(data_in.features);
            }
        }
    }
};